export default "__VITE_ASSET__CQ1qjo5c__"